import { cva } from 'class-variance-authority'
import { cn } from '@/lib/utils'
import {ReactNode} from "react";

const textVariants = cva('flow text col-span-full lg:col-span-8', {
    variants: {
        variant: {
            medium: 'text-base md:text-lg',
            base: 'text-base',
            small: 'text-sm'
        },
        position: {
            left: 'lg:col-start-0',
            center: 'lg:col-start-3',
            right: 'lg:col-start-5'
        }
    },
    defaultVariants: {
        variant: 'base',
        position: 'left'
    }
})

interface TextProps {
    id?: number;
    variant?: "medium" | "base" | "small" | null | undefined;
    position?: "left" | "center" | "right" | null | undefined;
    raw?: string | null;
    className?: string;
    children: ReactNode;
}

const Text = ({ id, variant, position = 'left', raw = null, className, children }: TextProps) => {
    if (raw) {
        return (
            <div
                data-component-id={id}
                className={cn(textVariants({ variant, position }), className)}
                dangerouslySetInnerHTML={{ __html: raw }}
            />
        )
    }
    return (
        <div data-component-id={id} className={cn(textVariants({ variant, position }), className)}>
            {children}
        </div>
    )
}

// const TextFetch = async ({ locale, id }) => {
//    const content = await getText(locale, id)
//
//    return <Text id={content.id} variant={content.appearance} position={content.position} raw={content.translations[0].text} />
//}

export { Text }
